/** 最大横幅px */
export const RAW_MAX_WIDTH = 800
/** 最大縦幅px */
export const RAW_MAX_HEIGHT = 800
/** 画質 0 - 1 の少数（圧縮時に使用） */
export const IMAGE_QUALITY = 0.9
/** 画像取得時のエラーコード */
export const IDB_ERROR_CODE = 'idb_11'

/** S3同期時、S3に施す操作 */
export const OPERATION = {
  /** S3に保存する */
  INSERT: 'insert',
  /** S3から削除する */
  DELETE: 'delete',
  /** 何もしない */
  STAY: 'stay'
} as const
